<template>
    <button class='button' type="button" @click='buttonClick' :style='[element.element_config.compiled_styles, custom_styles.button]' :class='[classes.button]' v-html='element.element_config.config.text'>

    </button>
</template>

<script>
import format_custom_styles from "@/page_builder/builder/builder_tools/functions/format_custom_styles.js";

export default {
    components: {},
    props:['element', 'page_builder_mode'],
    mixins: [format_custom_styles],
    data(){
        return{
            styles:{},
            classes: {}
        }
    },
    methods:{
        buttonClick(){
            if(typeof this.element.element_config.config.url !== 'undefined'){
                if(this.element.element_config.config.url !== '' && !this.page_builder_mode){
                    if(this.element.element_config.config.url_type != 'external'){
                        this.$router.push(this.element.element_config.config.url);
                    }
                    else{
                        window.location.href = this.element.element_config.config.url;
                    }
                }
            }
        },
        setClasses(){
            if(this.element.element_config.compiled_classes != null){
                this.classes = this.element.element_config.compiled_classes;
            }
        }
    },
    watch:{
        'element': {
            handler(){
                this.setCustomCssStyles(this.element.element_config.custom_styles); //From mixin
                this.setClasses();
            },
            deep: true
        }
    },
    mounted(){
        this.setCustomCssStyles(this.element.element_config.custom_styles); //From mixin
        this.setClasses();
    }
}
</script>

<style lang="scss" scoped>
.button{
    cursor: pointer;
}
</style>